import React from "react";

const Hero = () => (
  <div className="relative min-h-[16rem] sm:min-h-[20rem] lg:min-h-[24rem] flex items-center justify-center overflow-hidden bg-black">
    <div className="absolute inset-0 bg-gradient-to-br from-black via-gray-900 to-black opacity-95" />
    <div className="absolute inset-0 opacity-10">
      <div
        className="w-full h-full"
        style={{
          backgroundImage: `radial-gradient(circle at 20px 20px, white 1px, transparent 1px)`,
          backgroundSize: "40px 40px",
        }}
      />
    </div>

    <div className="relative z-10 text-center max-w-4xl mx-auto px-6">
      <p className="text-[10px] sm:text-xs md:text-[11px] tracking-[0.3em] uppercase text-gray-400 mb-4 sm:mb-6">
        Insights • Analysis • Expertise
      </p>
      <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-thin tracking-tight leading-tight mb-3 sm:mb-4 text-white">
        Thought Leadership
      </h1>
      <h2 className="text-sm sm:text-base md:text-lg font-light tracking-wide text-gray-300">
        AI Insights &amp; Industry Intelligence
      </h2>
    </div>
  </div>
);

export default Hero;
